import React from 'react';
import { Field, SwitchRow } from './Dialog';
import { D2L_REMINDER_INTERVALS } from '../utils/d2lSessionReminder';

export default function D2LSessionReminderSettings({ value, onChange, idPrefix, disabled = false, isCreate = false }) {
  const intervals = [...new Set([...D2L_REMINDER_INTERVALS, value.intervalMinutes])].sort((a, b) => a - b);
  return (
    <div style={{ marginTop: 16 }}>
      <SwitchRow
        id={`${idPrefix}-d2l-reminder`}
        title="Remind students to keep D2L active"
        description="Shows an IDE dialog for D2L-signed-in students. Does not refresh D2L automatically."
        checked={value.enabled}
        onChange={e => onChange({ enabled: e.target.checked })}
        disabled={disabled}
      />
      {isCreate && <p style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 6 }}>
        On by default for new D2L-only labs. You can turn this off.
      </p>}
      {value.enabled && (
        <Field label="D2L reminder interval" htmlFor={`${idPrefix}-d2l-reminder-interval`}
          hint="Choose an interval shorter than your institution's D2L inactivity timeout.">
          <select
            id={`${idPrefix}-d2l-reminder-interval`}
            value={value.intervalMinutes}
            onChange={e => onChange({ intervalMinutes: Number(e.target.value) })}
            disabled={disabled}
            className="form-input"
          >
            {intervals.map(minutes => <option key={minutes} value={minutes}>Every {minutes} minutes</option>)}
          </select>
        </Field>
      )}
    </div>
  );
}
